/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {KitchenDramaSushiManiaInitData} from "../server/KitchenDramaSushiManiaData";
import {KitchenDramaSushiManiaTextStyles} from "../config/KitchenDramaSushiManiaTextStyles";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";

export class KitchenDramaSushiManiaIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000, //Default 0x000000
            backgroundAlpha:0.0, //Default 0.4
            bulletColor:0xffffff, //Default 0xffffff

        },
        stampColor:0xFFFFFF
    };

    stampConfig:StampConfig = {
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    public bgSprite:PIXI.Sprite;
    public bgTile:PIXI.TilingSprite;

    constructor() {

    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("feature1", "resources/images/kamisabi.png");
        imgLoader.add("feature2", "resources/images/freespins.png");

        imgLoader.add("feature3", "resources/images/ninja.png");
        imgLoader.add("logo", "resources/images/logo.png");
        imgLoader.add("tile", "resources/images/bg-tile.png");


        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add({
            family: "Komika Text InGame",
            weight: FontWeight.NORMAL,
            style: FontStyle.NORMAL,
            url: "/resources/fonts/KOMTXT__.woff",
        });
        fontLoader.add({
            family: "Futura LT",
            weight: FontWeight.NORMAL,
            style: FontStyle.NORMAL,
            url: "/resources/fonts/FuturaLT-CondensedExtraBold.woff",
        })

        return Promise.all([fontLoader.load(), imgLoader.load()]).then(value => {
            this.initGraphics();
            return this;
        });
    }

    onResize():void {
        this.bgSprite.width = NolimitApplication.screenBounds.width;
        this.bgSprite.height = NolimitApplication.screenBounds.height;
        this.bgTile.width = NolimitApplication.screenBounds.width;
        this.bgTile.position.set(
            NolimitApplication.screenBounds.left -360,
            NolimitApplication.screenBounds.top -360,
        )
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        this.bgSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgSprite.tint = 0x478baf;
        this.bgSprite.width = NolimitApplication.screenBounds.width;
        this.bgSprite.height = NolimitApplication.screenBounds.height;
        this.bgSprite.anchor.set(0.5, 0.5);

        this.bgTile = new PIXI.TilingSprite(ImgLoader.getImgTexture("tile"),84,450);
        this.bgTile.width = NolimitApplication.screenBounds.width;
        this.bgTile.position.set(
            NolimitApplication.screenBounds.left -360,
            NolimitApplication.screenBounds.top -360,
        )

        this.background.addChild(this.bgSprite);
        this.background.addChild(this.bgTile);

        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();
/*
        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);
*/

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        this.pages = [
            new SlideShowPage(ImgLoader.getImgTexture("feature1"), "Kamisabi Second Chance"),
            new SlideShowPage(ImgLoader.getImgTexture("feature2"), KitchenDramaSushiMania.apiPlugin.translations.translate("Wild Sushi Free Spins"), undefined, false),
            new SlideShowPage(ImgLoader.getImgTexture("feature3"), "Bunshin Wilds ")
        ];

        for (let page of this.pages){
            for (let child of page.children) {
                if (isPIXITextField(child)){
                    (<PIXI.Text>child).style = KitchenDramaSushiManiaTextStyles.FEATURE_SPLASH_TEXT_STYLE;
                }
            }
        }

    }
}

export function isPIXITextField(value:any):value is PIXI.Text {
    return value.style != undefined && value.text != undefined;
}